import ObjectView from './container/index';

export default ObjectView;



// WEBPACK FOOTER //
// ./src/views/ObjectView/index.js